import Hls from 'hls.js';
import { useEffect, useRef, useState } from 'react';

/**
 * Превью потока прямо в админке. В dev и для администратора поток отдаётся через
 * /internal/hls; зрители в проде идут через nginx по ссылке /s/<token>/<envelope>/.
 */
export function Player({ src, autoPlay = true }: { src: string; autoPlay?: boolean }) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    setError(null);

    // Safari и iOS играют HLS нативно — hls.js там не нужен и мешает.
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src;
      if (autoPlay) void video.play().catch(() => undefined);
      return;
    }

    if (!Hls.isSupported()) {
      setError('Браузер не поддерживает MSE — превью недоступно');
      return;
    }

    const hls = new Hls({ lowLatencyMode: true, backBufferLength: 30 });
    hls.loadSource(src);
    hls.attachMedia(video);
    hls.on(Hls.Events.MANIFEST_PARSED, () => {
      if (autoPlay) void video.play().catch(() => undefined);
    });
    hls.on(Hls.Events.ERROR, (_event, data) => {
      if (!data.fatal) return;
      setError(`${data.type}: ${data.details}`);
      hls.destroy();
    });

    return () => hls.destroy();
  }, [src, autoPlay]);

  return (
    <div>
      <video ref={videoRef} className="player" controls muted playsInline />
      {error && <p className="error-text mono" style={{ marginTop: 8 }}>{error}</p>}
    </div>
  );
}
